// React
import React from 'react';
//external libs
import { get } from 'lodash';
// Componentes
import CustomButton from '../common/buttons/custom-button';
// Styles
import useStyles from './ShowPhoneButton.styles';

const ShowPhoneButton = ({ classes, onClick, showPhoneText }) => {
  const componentClasses = useStyles();
  return (
    <CustomButton
      classes={{
        root: get(componentClasses, 'root', null),
        submitButton: get(componentClasses, 'submitButton', null),
      }}
      fullWidth={false}
      color='primary'
      text={showPhoneText}
      onClick={onClick}
      variant='text'
    />
  );
};

ShowPhoneButton.defaultProps = {
  classes: {},
  onClick: () => {},
};
export default ShowPhoneButton;
